// components/Modal/UploadImage/UploadImageModal.tsx
import React from "react";
import Modal from "components/Modal";
import { UploadImage } from "components/Forms/UploadImage/UploadImage";
import { useModalStore, Modal as ModalKey } from "stores/modal/useModalStore";

const UploadModal = (props) => {
  const current = useModalStore(s => s.current);
  const overlay = useModalStore(s => s.overlay);      
  const close = useModalStore(s => s.close);
  const closeOverlay = useModalStore(s => s.closeOverlay);

  const isOpen = current === ModalKey.Upload || overlay === ModalKey.Upload;

  const handleClose = overlay === ModalKey.Upload ? closeOverlay : close;

  return (
    <Modal
      modalIsOpen={isOpen}
      closeModal={handleClose}
      className={props?.image ? "!text-[20px] !capitalize !w-[662px]" : ``}
      style={{ padding: '40px' }}
      title={props?.image ? "Edit Thumbnail" : "choose a new image"}
    >
      {{
        content: <UploadImage />,
      }}
    </Modal>
  );
};

export default UploadModal;
